import { render } from "./tracking.vue?vue&type=template&id=72c961bf"
import script from "./tracking.vue?vue&type=script&lang=js"
export * from "./tracking.vue?vue&type=script&lang=js"

import "./tracking.vue?vue&type=style&index=0&id=72c961bf&lang=less"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__